export default function MetricCard({ title, value, subtitle, color = '#4ecca3' }) {
  return (
    <div style={{
      background: '#fff', borderRadius: 8, padding: '20px 24px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)', minWidth: 160,
    }}>
      <div style={{ fontSize: 12, color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
        {title}
      </div>
      <div style={{ fontSize: 28, fontWeight: 700, color, marginTop: 4 }}>
        {value}
      </div>
      {subtitle && <div style={{ fontSize: 12, color: '#aaa', marginTop: 4 }}>{subtitle}</div>}
    </div>
  );
}
